import { Navigate } from "react-router-dom";

/**
 * Permission gate for individual routes.
 *
 * Usage in route table:
 *   <Route path="products" element={<Guard p="productsAccess"><Products/></Guard>} />
 *
 * Reads `userPermissions` from localStorage (set during login). Missing/false
 * permission → redirect to /dashboard. Routes without `p` are open to any
 * authenticated user (e.g. Dashboard, Change Password).
 *
 * Note: defense-in-depth — Sidebar already filters its own list by permission,
 * but a savvy user can paste a URL. The route guard catches that. The API also
 * enforces the same permission server-side (the source of truth).
 */
export default function Guard({ p, children }) {
  if (!p) return children;
  let permissions = {};
  try {
    permissions = JSON.parse(localStorage.getItem("userPermissions")) || {};
  } catch {
    permissions = {};
  }
  if (!permissions[p]) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
